
























































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import skyconText from '@/utils/skyconText'
import CimissDataService from '@/service/CimissDataService'
import warningImg from '@/utils/warningImg'
import windElement from '@/utils/windElement'
import townList from "@/assets/json/townList.json";
import { Icon, Toast } from 'vant';
export default Vue.extend({
  components: {
    Icon
  },

  data() {
    return {
      data: {},
      warnInfos: [],
      adminCode: config.defaultStationObj.adminCode,
      alarm: {},
      modalShow: false,
    }
  },
  created() {
    this.getWarnInfo()
    // this.getWarninfoData()

  },
  methods: {
    getWarnInfo() {
      CimissDataService.warningSignalList(this.adminCode).then((res: any) => {
        // CimissDataService.warningSignalList('610000').then((res: any) => {
        if (res) {
          const alarms = res
          this.warnInfos = alarms.filter((e: any) => {
            e.imgUrl = warningImg.getImgSrc(`${e.signaltype}${e.signallevel}`)
            e.fyzn = warningImg.getFyzn(`${e.signaltype}${e.signallevel}`)
            return e
          })

        } else {
          this.warnInfos = []
        }
      });
    },
    getWarninfoData() {
      const params = {
        areaCode: config.defaultStationObj.adminCode + '000000',
        startTime: moment().add(-600, 'h').format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD')
      }
      request.get('/warninfo/getEarlyWarnHisInfo', params).then(res => {

        if (res && res.result) {
          const alarms = res.result.alarms
          this.warnInfos = alarms.filter((e: any) => {
            e.imgUrl = warningImg.getImgSrc(`${e.typename}${e.level}`)
            return e
          })

        } else {
          this.warnInfos = []
        }
      });
    },
    showModal(item: any) {
      this.alarm = item
      this.modalShow = true
    },

  },
  filters: {
    dtFormat(datetime: number) {
      const time = moment(datetime, 'YYYYMMDDHHmmss')
      return time.add(8, 'hours').format('YYYY年M月D日HH时mm分')
    }
  }
})
